// extracted by mini-css-extract-plugin
module.exports = {"menu":"_3P-mL","menu_col":"_2T47b"};